import Slide from "@material-ui/core/Slide";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { userFarmDetail } from "../../../config/farmDetails";
import DropdownOptions from "../../../constants/DropdownOptions";
import { unallocatedTicketsListAction } from "../../../modules/riskmanagement/action";
import "../../../style";
import AllMainFarmSelectedDialog from "../../Common/AllMainFarmSelectedDialog";
import { isSuperAdmin } from "../../Common/CheckAuthorization";
import CreateTable from "../../CreateTable";
import Loader from "../../Loader";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class UnallocatedTickets extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false;
    this.state = {
      fetchingComplete: false,
      headerRows: {
        counterpartName: "Counterpart",
        ticketNumber: "Ticket",
        commodityName: "Commodity",
        loadDate: "Load Date",
        loadNumber: "Load Number",
        field_estimated_load_bushels: "Field Est. Load Bushels",
        payloadDelivered: "Net Bushels Reconciled",
        payloadBalance: "Balance after Reconciled",
        stage: "Status"
      },
      order: "desc",
      orderBy: "id",
      open: false,
      contractName: ""
    };
  }

  componentWillMount() {
    const {
      unallocatedTicketsListAction,
      SubFarmId = userFarmDetail().id,
      selectedYear
    } = this.props;
    if(!isSuperAdmin() || this.props.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id){
      unallocatedTicketsListAction(SubFarmId , selectedYear);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.rowRisk &&
      this.props.rowRisk !== nextProps.rowRisk &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    if (nextProps.SubFarmId && nextProps.SubFarmId !== this.props.SubFarmId && nextProps.SubFarmId !== DropdownOptions.ALL_MAIN_FARM.id) {
      this.props.unallocatedTicketsListAction(nextProps.SubFarmId, nextProps.selectedYear);
    }
    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear &&
      (!isSuperAdmin() || nextProps.MainFarmId !== DropdownOptions.ALL_MAIN_FARM.id)) {
        this.props.unallocatedTicketsListAction(nextProps.SubFarmId, nextProps.selectedYear);
    }
  }

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };
  render() {
    const { headerRows, order, orderBy, fetchingComplete } = this.state;
    const { rowRisk, ErrorMessage } = this.props;
    return (
      <div className=" ticket-body">
        <div className="flex-display ticket-header">
          <h3 className="mainHeading">Unallocated Tickets</h3>
        </div>

        {isSuperAdmin() && this.props.MainFarmId === DropdownOptions.ALL_MAIN_FARM.id ? (
          <AllMainFarmSelectedDialog/>
        ) : (
            <div> 
            {fetchingComplete ? (
           <CreateTable
            order={order}
            orderBy={orderBy}
            headerRows={headerRows}
            rowData={rowRisk}
            onRequestSort={this.handleRequestSort}
            isMenuRequired={false}
            highlightPrimaryColumn={true}
            />
            ) : (
            <Loader />
            )}
          </div>
        )}
        
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    rowRisk: state.riskReducer.unallocatedList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId,
    selectedYear: state.harvestYearReducer.selectedYear
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ unallocatedTicketsListAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UnallocatedTickets);



// WEBPACK FOOTER //
// ./src/components/private/RiskManagement/UnallocatedTickets.js